module.exports = __webpack_public_path__ + "de8c0850b4b34a8adc8f050915c3c583.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Maven_Pro/MavenPro-Regular.ttf
// module id = 369
// module chunks = 0